module.exports = __webpack_public_path__ + "img/company-honor-MHRA-20240411.d168769f.jpg";